import { LoadingOutlined, LockOutlined, SafetyCertificateOutlined, UnlockOutlined } from '@ant-design/icons'
import styles from '@/pages/CashPage.module.css'

function shortShift(label: string) {
  if (/открыт/i.test(label)) return 'Открыта'
  if (/закрыт/i.test(label)) return 'Закрыта'
  return label
}

function shortFn(label: string) {
  if (label.includes('Всё в порядке')) return 'ОК'
  if (/нет данных/i.test(label)) return 'Нет данных'
  if (/ошибк/i.test(label)) return 'Ошибка'
  return label
}

export function ShiftCell({ label }: { label?: string }) {
  const s = label != null && label !== '' ? String(label) : '—'
  if (s === '—') return <span className={styles.muted}>—</span>
  const open = /открыт/i.test(s)
  const closed = /закрыт/i.test(s)
  return (
    <span
      className={`${styles.metaChip} ${open ? styles.metaOk : closed ? styles.metaWarn : styles.metaMuted}`}
      title={s}
    >
      {open ? <UnlockOutlined /> : <LockOutlined />}
      <span>{shortShift(s)}</span>
    </span>
  )
}

export function FnCell({ label }: { label?: string }) {
  const s = label != null && label !== '' ? String(label) : '—'
  if (s === '—') return <span className={styles.muted}>—</span>
  const ok = s.includes('Всё в порядке')
  const bad = /ошибк/i.test(s)
  return (
    <span
      className={`${styles.metaChip} ${ok ? styles.metaOk : bad ? styles.metaErr : styles.metaWarn}`}
      title={s}
    >
      <SafetyCertificateOutlined />
      <span>{shortFn(s)}</span>
    </span>
  )
}

export function StatusDot({ online }: { online: boolean }) {
  return (
    <span className={`${styles.status} ${online ? styles.statusOn : styles.statusOff}`}>
      <i className={styles.dot} />
      {online ? 'Онлайн' : 'Оффлайн'}
    </span>
  )
}

export function MetaLoadingCell({ label = 'Загрузка' }: { label?: string }) {
  return (
    <span className={`${styles.metaChip} ${styles.metaLoading}`} title={label}>
      <LoadingOutlined spin />
      <span>{label}</span>
    </span>
  )
}
